/*
 * An object containing properties for button events
 */
export class ButtonEvent {
  /**
   * The event name
   */
  eventName: string;

  /**
   * The button ID
   */
  id?: string;

  /**
   * The button name
   */
  name?: string;

  /**
   * The initial button value
   */
  value?: string;
}
